{
  "id": 10,
  "location": "cafe",
  "difficulty": "easy",
  "moves": 10,
  "kinds": 5,
  "goals": [
    { "type": "mud" },
    { "type": "collect", "kind": "croissant", "count": 24 }
  ],
  "stars": [3240, 4790],
  "board": [
    ". . . . . . . .",
    ". . . . . . . .",
    ". . x x x x . .",
    ". . x . . x . .",
    ". . x . . x . .",
    ". . x x x x . .",
    ". . . . . . . .",
    ". . . . . . . ."
  ],
  "calibration": { "runs": 1000, "winRate": 0.924, "movesLeft": 3.5, "closeLosses": 0.038, "target": 0.92 }
}
